"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppCached = void 0;
/**
 * Checks if an app is already cached in the federation instances
 * @param appName The name of the app to check
 * @returns boolean indicating if the app is cached
 */
const isAppCached = (appName) => {
    // Check if federation is available
    if (typeof window === 'undefined' || !window.__FEDERATION__) {
        return false;
    }
    // Check each federation instance
    for (const instance of window.__FEDERATION__.__INSTANCES__) {
        // Check if the instance has a module cache
        if (instance.moduleCache && instance.moduleCache instanceof Map) {
            // Check if any module in the cache matches the app name
            for (const module of instance.moduleCache) {
                if (module[0] === appName) {
                    return true;
                }
            }
        }
    }
    if (window[appName]?.init && typeof window[appName]?.init === 'function' && window[appName]?.get && typeof window[appName]?.get === 'function') {
        return true;
    }
    return false;
};
exports.isAppCached = isAppCached;
//# sourceMappingURL=isAppCached.js.map